module.exports = __webpack_public_path__ + "img/no_product_image_850.264d2a2e.jpg";